import Vue from 'vue';
import Vuex from 'vuex';

import analytics from './modules/analytics';
import auth from './modules/auth';
import chat from './modules/chat';
import homeProfiles from './modules/homeProfiles';
import invitationMessages from './modules/invitationMessages';
import locations from './modules/locations';
import matchGame from './modules/matchGame';
import members from './modules/members';
import preferences from './modules/preferences';
import visitors from './modules/members';
import topChoices from './modules/members';
import notifications from './modules/notifications';
import popups from './modules/popups';
import profiles from './modules/profiles';
import settings from './modules/settings';
import shop from './modules/shop';
import user from './modules/user';
import userMedia from './modules/userMedia';
import router from './modules/router';
import registration from './modules/registration';
import userCounters from './modules/userCounters';

Vue.use(Vuex);

const debug = process.env.NODE_ENV !== 'production';
export default new Vuex.Store({
  modules: {
    analytics,
    auth,
    chat,
    homeProfiles,
    invitationMessages,
    locations,
    matchGame,
    members,
    preferences,
    visitors,
    topChoices,
    notifications,
    popups,
    profiles,
    settings,
    shop,
    user,
    userCounters,
    userMedia,
    registration,
    router,
  },
  strict: debug,
});

